import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(1),
    width: '100% !important',
    ['@media only screen and (max-width: 812px)']: {
      width: '100% !important',
    },
  },
  titlePrincipal: {
    fontWeight: 'bold !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    // fontSize: 30,
    marginTop: theme.spacing(2)
  },
  title: {
    fontWeight: 'bold !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    // fontSize: 13,
    marginTop: theme.spacing(1)
  },
  subTitle: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
    // fontSize: 19,
    // fontWeight: 'bold !important',
    // marginTop: theme.spacing(1)
  },
  titleRed: {
    fontWeight: 'bold !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    textAlign: 'center !important',
    color: theme.palette.primary.main,
    // fontSize: 13,
    marginTop: theme.spacing(1)
  },
  subTitleC1: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
    color: '#FFC200',
    // fontSize: 19,
    // fontWeight: 'bold !important',
    // marginTop: theme.spacing(1)
  },
  subTitleC2: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
    color: 'red',
    // fontSize: 19,
    // fontWeight: 'bold !important',
    // marginTop: theme.spacing(1)
  },
  subTitleC3: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
    color: 'green',
    // fontSize: 19,
    // fontWeight: 'bold !important',
    // marginTop: theme.spacing(1)
  },


  subTitleStatus: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
    // fontSize: 19,
    fontWeight: 'bold !important',
    marginTop: theme.spacing(1),
    color: theme.palette.success.main
  },

  title2: {
    fontWeight: 'bold !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    // fontSize: 13,
    marginTop: theme.spacing(1)
  },
  subTitle2: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
    marginTop: theme.spacing(1)
  },
  titleEstatus: {
    alignSelf: 'flex-start',
    fontWeight: 'bold',
    // fontWeight: 'bold',
    // alignItems: 'center',
    // justifyContent: 'center',
    // fontSize: 20,
    // marginTop: theme.spacing(2),
    color: '#7DC133'
  },
  margin: {
    margin: theme.spacing(1),
  },
  passBtn: {
    display: 'flex',
    //outline: 'solid 1px tomato !important',
    width: '100% !important',
    justifyContent: 'flex-end'
  },
  loginButton: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(4)
  },
  topImage: {
    padding: theme.spacing(1),
    width: '45% !important'
  },
  captionRegister: {
    width: '100% !important',
  },
  wc100: {
    width: '100% !important',
    paddingTop: '5px !important',
    paddingLeft: '1px !important',
    paddingRight: '1px !important',
    paddingBottom: '1px !important',
  },
  pc12: {
    // padding: '12px !important',
    padding: '1px !important',
  },
  tAgCenter: {
    textAlign: 'center !important'
  },
  colContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  //Table: 

  head: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: '#FFFFFF !important',
  },
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },

  finalButton: {
    marginTop: theme.spacing(6)
  },
  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '50% 50%',
    // ['@media only screen and (max-width: 812px)']: {
    //   // gridTemplateColumns: '5% 90% 5%',
    //   gridTemplateColumns: '50% 50%',
    // },
    overflowY: 'none !important',
    marginBottom: '5% !important'
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'center !important',
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    justifyContent: 'center !important',
    overflowY: 'none',
  },

  containerCalenGral: {
    width: '100%',
    //maxHeight: '30%',
    overflowY: 'auto !important',
    ['@media only screen and (max-width: 812px)']: {
      overflowY: 'auto !important',
      //maxHeight: '20%',
    },
  },
  containerCalendarResult: {
    display: 'grid !important',
    gridTemplateColumns: '25% 25% 25% 25%',
    // ['@media only screen and (max-width: 812px)']: {
    //   // gridTemplateColumns: '5% 90% 5%',
    //   gridTemplateColumns: '50% 50%',
    // },
    overflowY: 'none !important',
    // marginBottom: '5% !important'
  },
  ColumnCalendarResult1: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'center !important',
  },
  ColumnCalendarResult2: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'center !important',
  },
  ColumnCalendarResult3: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'center !important',
  },
  ColumnCalendarResult4: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    justifyContent: 'center !important',
    overflowY: 'none',
  },
  ContainerPagos: {
    width: '100% !important',
    // height: '83vh',
    overflowY: 'hidden',
    zIndex: 3,
    // display: 'flex',
    // alignItems: 'center',
    // ['@media only screen and (max-width: 812px)']: {
    //   height: '80vh',
    // }
  },

}))
